var _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebCloudPlansNg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 82,
    viewBox: "0 0 48 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84 0C1.72 0 0 1.82 0 4.063v55.873C0 62.181 1.72 64 3.84 64h40.32c2.12 0 3.84-1.82 3.84-4.063V4.063C48 1.82 46.28 0 44.16 0H3.84z",
    fill: "#E3E3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 64h8v8.667L43 76h-6l-1-3.333V64zM38 76h4v1h-4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 74h2v7h-2v-7z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M44 52a4 4 0 01-4 4H5a1 1 0 110-2h29.44c.931 0 1.56-1.07 1.56-2a4 4 0 118 0zm-4 2a2 2 0 100-4 2 2 0 000 4z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iODIiIHZpZXdCb3g9IjAgMCA0OCA4MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy44NCAwQzEuNzE5MjMgMCAwIDEuODE5MjkgMCA0LjA2MzQ5VjU5LjkzNjVDMCA2Mi4xODA3IDEuNzE5MjMgNjQgMy44NCA2NEg2Ljk2Nzc0SDMzLjZINDQuMTZDNDYuMjgwOCA2NCA0OCA2Mi4xODA3IDQ4IDU5LjkzNjVWNC4wNjM0OUM0OCAxLjgxOTI5IDQ2LjI4MDggMCA0NC4xNiAwSDMuODRaIiBmaWxsPSIjRTNFM0UzIi8+CiAgICA8ZyBvcGFjaXR5PSIwLjkiPgogICAgICAgIDxwYXRoIGQ9Ik0zNiA2NEg0NFY3Mi42NjY3TDQzIDc2SDM3TDM2IDcyLjY2NjdWNjRaIiBmaWxsPSIjMjIyMjIyIi8+CiAgICAgICAgPHBhdGggZD0iTTM4IDc2SDQyVjc3SDM4Vjc2WiIgZmlsbD0iIzIyMjIyMiIvPgogICAgICAgIDxwYXRoIGQ9Ik0zOSA3NEg0MVY4MUgzOVY3NFoiIGZpbGw9IiMyMjIyMjIiLz4KICAgIDwvZz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDQgNTJDNDQgNTQuMjA5MiA0Mi4yMDkyIDU2IDQwIDU2SDVDNC40NDc3MiA1NiA0IDU1LjU1MjMgNCA1NUM0IDU0LjQ0NzcgNC40NDc3MiA1NCA1IDU0SDM0LjQ0MDhDMzUuMzcxMiA1NCAzNiA1Mi45MzA0IDM2IDUyQzM2IDQ5Ljc5MDggMzcuNzkwOCA0OCA0MCA0OEM0Mi4yMDkyIDQ4IDQ0IDQ5Ljc5MDggNDQgNTJaTTQwIDU0QzQxLjEwNDYgNTQgNDIgNTMuMTA0NiA0MiA1MkM0MiA1MC44OTU0IDQxLjEwNDYgNTAgNDAgNTBDMzguODk1NCA1MCAzOCA1MC44OTU0IDM4IDUyQzM4IDUzLjEwNDYgMzguODk1NCA1NCA0MCA1NFoiLz4KPC9zdmc+Cg==";
export { SvgWebCloudPlansNg as ReactComponent };